import { Component, Input } from '@angular/core';

@Component({
  selector: 'wr-unsupported-widget',
  standalone: true,
  template: `
    <div
      class="border border-dashed border-red-400 text-red-600 text-sm p-3 m-5 rounded"
      style="background: rgba(255,0,0,0.03);"
    >
      ⚠️ Unsupported widget type:
      <strong>{{ type }}</strong>
    </div>
  `,
})
export class UnsupportedWidgetComponent {
  @Input() type!: string;
}
